import CountdownTimer from "./CountdownTimer";

function App() {
  return (
    <div className="app">
      <CountdownTimer />
    </div>
  );
}

export default App;